import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { LinkPid as Link } from '@alfa-bank/site-link/link-pid';
import { Button } from '@alfa-bank/site-button-v2';
import { Aligner } from '@alfa-bank/site-aligner';
import { DataLayer } from '@alfa-bank/site-data-layer';
import { EmptyCard } from '@alfa-bank/site-empty-card';
import { Hr } from '@alfa-bank/site-hr';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';
import { createElement } from 'react';

import styles from './desktop.css';
import { CatalogCardDesktop as Component } from './catalog-card-desktop';
import type { IDepsDesktop, TCatalogCardDesktop, IProps } from './models';

/**
 * TODO: Отрефакторить, после того как придумаем
 * как задавать значения по умолчанию для styler
 */
export const CatalogCardDesktop = (props: IProps) =>
    createElement(
        createWidget<IDepsDesktop, TCatalogCardDesktop>({
            styles,
            Block,
            Layout,
            Grid,
            Img,
            Text,
            Link,
            Button,
            Aligner,
            DataLayer,
            EmptyCard,
            Hr,
            useNamedContainers,
        })(Component),
        {
            ...props,
            styler: {
                borderRadius: 32,
                ...props.styler,
            },
        }
    );
